<script lang="ts">
	import GradientBorder from '$lib/util/GradientBorder.svelte';
	import ProcessingButton from '$lib/util/ProcessingButton.svelte';
	import { scWalletAccountResolver, walletAddress } from '$lib/wallet/store';
	import { tosBeingSigned } from '../popupsStore';
	import { signMessageAndSendToServer } from './tos';
	import { isCyberWallet, getSignerAddress } from '@cyberlab/cyber-app-sdk';
</script>

<GradientBorder
	gradient="bg-fx-gradient-6"
	paddingClass="p-px"
	borderRadius="rounded-2xl"
	outerClassList="w-fit h-fit max-w-[400px]"
	innerClassList="bg-fx-black"
>
	<div
		class="bg-fx-gradient-8-50 text-fx-white p-4 sm:p-8 rounded-2xl w-[95vw] sm:w-fit sm:min-w-[400px]"
	>
		<div class="text-fx-gradient-5 text-xl font-semibold">Terms & Conditions Agreement</div>
		<div class="border-t border-t-fx-grey-800 w-full mb-6 mt-2" />
		<div>
			<div class="text-fx-grey-100 font-semibold text-sm">
				By using Polynomial, I agree to the <a
					rel="noreferrer"
					href="https://www.polynomial.fi/terms-conditions"
					target="_blank"
					class="text-fx-pink"
					>Terms & Conditions
				</a>
				and
				<a
					href="https://www.polynomial.fi/privacy-policy"
					target="_blank"
					class="text-fx-pink"
					rel="noreferrer"
				>
					Privacy Policy.</a
				>
			</div>

			<div class=" my-6 rounded-xl border border-fx-grey-600 p-6 max-h-72 overflow-y-auto">
				<ul class="list-disc text-fx-grey-200 text-sm">
					<li>
						I am not a person or entities who reside in, are citizens of, are incorporated in, or
						have a registered office in the United States of America or any Prohibited Localities,
						as defined in the Terms & Conditions.
					</li>
					<li>
						I am not using, and will not in the future use, a VPN to mask my physical location from
						a restricted territory.
					</li>
					<li>
						I am lawfully permitted to access this site and use Polynomial under the laws of the
						jurisdiction on which I reside and am located.
					</li>
					<li>
						I will not in the future access this site or use Polynomial while located within the
						United States or any Prohibited Localities, as defined in the Terms & Conditions.
					</li>
					<li>I understand the risks associated with entering into using Polynomial.</li>
				</ul>
			</div>
			{#if $tosBeingSigned}
				<div class="mt-9">
					<ProcessingButton title="Sign in Metamask" />
				</div>
			{:else}
				<button
					class="mt-9 text-fx-black font-semibold text-center rounded-xl bg-fx-gradient-9 py-4 cursor-pointer hover:bg-opacity-70 w-full"
					on:click={() => {
						signMessageAndSendToServer(
							isCyberWallet() ? getSignerAddress() : $walletAddress,
							$scWalletAccountResolver
						);
					}}
				>
					<span class="py-0.5"> Sign and proceed </span>
				</button>
			{/if}
		</div>
	</div>
</GradientBorder>
